<ng-container *ngIf="!noKvkService">
    <h3 i18n="@@configurator.company.kvk-title">Select the company with the help of our company picker:</h3>
    <mg-checkout-company-picker (companySelected)="onCompanySelected($event)"></mg-checkout-company-picker>
    <h3 i18n="@@configurator.company.alternative-title">Or fill in the company details manually:</h3>
</ng-container>

<form [formGroup]="form">
    <mat-form-field class="company-field__l">
        <mat-label i18n="@@configurator.company.label-name">Company name</mat-label>
        <input matInput formControlName="name" required="true" />
    </mat-form-field>
    <ng-container *ngIf="hasCheckout">
        <mat-form-field class="company-field__s" *ngIf="needsChamberOfCommerceNumber">
            <mat-label i18n="@@configurator.company.label-chamber-of-commerce-nr">Chamber of commerce number</mat-label>
            <input matInput formControlName="chamberOfCommerceNr" required="true" />
        </mat-form-field>
        <mat-form-field class="company-field__m">
            <mat-label i18n="@@configurator.company.label-street">Street</mat-label>
            <input matInput formControlName="street" required="true" />
        </mat-form-field>
        <mat-form-field class="company-field__xs">
            <mat-label i18n="@@configurator.company.label-house-number">House number</mat-label>
            <input matInput formControlName="houseNumber" required="true" />
        </mat-form-field>
        <mat-form-field class="company-field__xs">
            <mat-label i18n="@@configurator.company.label-house-number-suffix">House number suffix</mat-label>
            <input matInput formControlName="houseNumberSuffix" />
        </mat-form-field>
        <mat-form-field class="company-field__m">
            <mat-label i18n="@@configurator.company.label-zip-code">Zip code</mat-label>
            <input matInput formControlName="zipcode" required="true" />
        </mat-form-field>
        <mat-form-field class="company-field__m">
            <mat-label i18n="@@configurator.company.label-city">City</mat-label>
            <input matInput formControlName="city" required="true" />
        </mat-form-field>
    </ng-container>
</form>
